import { publicAssetUrl } from './publicAssetUrl.js';

/**
 * Full URL to a Material symbol SVG in /public/img/svg (kebab-case file names).
 */
export function materialIconFullUrl(snakeName) {
    const kebab = String(snakeName || '')
        .trim()
        .replace(/[^a-z0-9_]/gi, '')
        .replace(/_/g, '-');
    const safe = kebab || 'help';

    return publicAssetUrl(`img/svg/${safe}.svg`);
}
